<template>
    <div class="w-full md:w-fit">
        <Button
            as="a"
            target="_blank"
            :href="
                urlFactory.makeGuestMeetingViewPageUrl(
                    meeting.bookingId,
                    reservation.companyCustomerId,
                )
            "
            :disabled="reservation.cannotReschedule"
            iconName="arrow-rotate"
            color="light"
            size="small"
            class="w-full"
        >
            Reschedule
        </Button>
    </div>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { type PropType } from 'vue'
    import Button from '@/Shared/Component/Button.vue'
    import Meeting from '@/App/Booking/Meeting/Entity/Meeting'
    import Reservation from '@/App/Booking/Reservation/Entity/Reservation'

    const props = defineProps({
        meeting: {
            type: Object as PropType<Meeting>,
            required: true,
        },
        reservation: {
            type: Object as PropType<Reservation>,
            required: true,
        },
    })
    const urlFactory = new UrlFactory()
</script>
